import React from 'react';
import styled from 'styled-components/macro';
import SimpleBar from "simplebar-react";
import 'simplebar-react/dist/simplebar.min.css';


const ScrollArea = ({ children, fadeHeight, center, ...restProps }) => (
    <StyledSimpleBar $fadeHeight={fadeHeight} $center={center} {...restProps}>
        {children}
    </StyledSimpleBar>
);


export default ScrollArea;


const StyledSimpleBar = styled(SimpleBar)`
	height: 100%;
    width: 100%;
    
    .simplebar-content-wrapper {
        padding-right: 3rem;
    }

    .simplebar-content {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        
        ${props => props.$center && `
            justify-content: center;
        `}
    }

	.simplebar-scrollbar:before {
		background: ${props => props.theme.primary_color};
    }

    ${props => props.$fadeHeight && `
        .simplebar-track.simplebar-vertical {
            top: ${props.$fadeHeight};
            bottom: ${props.$fadeHeight};
        }

        .simplebar-content-wrapper {
            padding-top: ${props.$fadeHeight};
            padding-bottom: ${props.$fadeHeight};

            mask-image: linear-gradient(
                to bottom,
                transparent,
                black ${props.$fadeHeight},
                black calc(100% - ${props.$fadeHeight}),
                transparent
            );
        }
    `}

`;
